<template>
    <div id="tryoutgroup-chooser">
        <v-btn
            id="tryout_group_chooser_serial"
            block
            class="font-weight-bold dark--text"
            depressed
            color="#FAFAFA"
            style="
                box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);
                border-radius: 4px;
            "
            @click="openGroupModal"
            v-if="$route.name === 'TryoutSerialForm'"
            >Tambah Serial</v-btn
        >
        <v-text-field
            id="tryout_group_chooser_group"
            outlined
            v-else
            v-model="group"
            readonly
            @click="openGroupModal"
            :placeholder="
                $route.name !== 'DetailPaketMapel'
                    ? 'Pilih Prasyarat'
                    : 'Pilih Tryout'
            "
            clearable
        ></v-text-field>

        <v-dialog
            v-model="showModal"
            transition="dialog-top-transition"
            width="940px"
            min-height="537px"
            max-height="771px"
            @click:outside="showModal = false"
        >
            <template v-slot:default="dialog">
                <v-card>
                    <v-card-text width="100%">
                        <app-datatable
                            :items="rows"
                            :headers="headers"
                            :has-custom-pagination="true"
                            :custom-pagination-per-page="pagination.perPage"
                            :custom-pagination-current-page="
                                pagination.currentPage
                            "
                            :hasAction="false"
                            v-on:dblClicked="onTryoutGroupChoosen($event)"
                            v-on:changePage="
                                pagination = {
                                    ...pagination,
                                    currentPage: $event,
                                }
                            "
                        ></app-datatable>
                    </v-card-text>
                    <v-card-text>
                        <div class="text-h2"></div>
                    </v-card-text>
                    <v-card-actions class="justify-end">
                        <v-btn text @click="dialog.value = false">Close</v-btn>
                    </v-card-actions>
                </v-card>
            </template>
        </v-dialog>

        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<style scoped>
.modal-container {
    width: 50%;
}
</style>

<script>
import DataTable from "@/modules/global/components/plugins/DataTable-c";
import Spinner from "@/modules/global/components/plugins/Spinner";
import TryoutService from "@/modules/tryout/services/tryout.js";

export default {
    name: "tryoutgroup-chooser",

    props: ["params", "group"],

    components: {
        "app-datatable": DataTable,
        "app-spinner": Spinner,
    },

    data: function () {
        return {
            isLoading: false,
            showModal: false,
            pagination: {
                currentPage: 1,
                perPage: 10,
                totalPages: 0,
            },
            headers: [
                { text: "No.", value: "no" },
                { text: "Tryout Group", value: "name" },
                { text: "Tipe", value: "type" },
                { text: "Kelas", value: "grade" },
            ],
            rows: [],
        };
    },

    watch: {
        group: function (val) {
            if (!val) {
                this.$emit("clearGroup");
            }
        },
    },

    methods: {
        changePages(page) {
            this.pagination.currentPage = page;
            this.params.page = page;
            this.params.per_page = this.pagination.perPage;
            this.openGroupModal();
        },

        openGroupModal: function () {
            this.isLoading = true;
            this.showModal = true;

            var context = this;
            this.params.page = this.pagination.currentPage;
            this.params.per_page = this.pagination.perPage;

            TryoutService.getListOfTryoutGroups(
                null,
                null,
                this.params,
                function (response) {
                    if (response.success) {
                        context.rows = [];
                        response.data.tryout_groups.forEach(
                            function (data, index) {
                                var row = {
                                    no: index,
                                    id: data.id,
                                    name: data.name,
                                    type: data.type,
                                    grade: data.grade,
                                };

                                context.pagination.totalPages = data.page;
                                context.rows.push(row);
                            },
                        );
                    }

                    context.isLoading = false;
                },
                this.grade,
                null,
            );
            context.isLoading = false;
        },

        onTryoutGroupChoosen: function (group) {
            this.group = group.name;
            this.showModal = false;
            this.$emit("dblClicked", group);
        },
    },
};
</script>



// WEBPACK FOOTER //
// TryoutGroupChooser.vue?46b6b284